import * as IoC from 'inversify';
import { registerCommand, registerQuery } from '@/app/tracking/api';
import { CompleteInteractionCommandName, UpdateInteractionStateTrackingCommandName,
  UpdateInteractionResultTrackingCommandName,
  QueryInteractionStatesTrackingQueryName,
  QueryInteractionResultsTrackingQueryName} from '../api'
import { interactionCommonTrackingModule } from '../common/di'
import { Scorm2004CompleteInteractionCommandHandler } from './scorm2004-complete-interaction-command-handler'
import { Scorm2004UpdateInteractionStateCommandHandler } from './scorm2004-update-interaction-state-command-handler'
import { Scorm2004UpdateInteractionResultCommandHandler } from './scorm2004-update-interaction-result-command-handler'
import { Scorm2004QueryInteractionStatesQueryHandler } from './scorm2004-query-interaction-states-query-handler'
import { Scorm2004QueryInteractionResultsQueryHandler } from './scorm2004-query-interaction-results-query-handler'

const interactionScorm2004TrackingModule = new IoC.ContainerModule((bind) => {
  registerCommand(CompleteInteractionCommandName, Scorm2004CompleteInteractionCommandHandler, bind);
  registerCommand(UpdateInteractionStateTrackingCommandName, Scorm2004UpdateInteractionStateCommandHandler, bind)
  registerCommand(UpdateInteractionResultTrackingCommandName, Scorm2004UpdateInteractionResultCommandHandler, bind)
  registerQuery(QueryInteractionStatesTrackingQueryName, Scorm2004QueryInteractionStatesQueryHandler, bind);
  registerQuery(QueryInteractionResultsTrackingQueryName, Scorm2004QueryInteractionResultsQueryHandler, bind);
})

export const interactionScorm2004TrackingModules = [
  interactionCommonTrackingModule,
  interactionScorm2004TrackingModule
]
